import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rp-footer',
  templateUrl: './rp-footer.component.html',
  styleUrl: './rp-footer.component.scss'
})
export class RpFooterComponent implements OnInit {

  // set the currenr year
  year: number = new Date().getFullYear();

  constructor() { }

  ngOnInit() {
  }

}
